import { URLS } from '@/constants'
import { isInNestedIframe } from '@/utils/browser'
import { isAgentApp } from '@/utils/environment'

import { connection } from './'
import { MESSAGE_PREFIX } from './constants'
import { InboxMessage } from './types'

export const normalizeAAPath = (pathname: string): string => {
  let normalizedPathname = pathname.replace('/apps/marketplace', '')

  // /apps route is the default route for AA
  if (!pathname || pathname === '/') {
    normalizedPathname = URLS.APPS.LINK
  }

  return normalizedPathname
}

export const sendPostMessage = (eventName: string, eventData: unknown) => {
  const message = {
    event_name: eventName,
    event_data: eventData || null,
  }

  // TODO: Remove after full 1CP migration for devs
  if (isInNestedIframe()) {
    return window.top?.postMessage(JSON.stringify(message), '*')
  }

  if (isAgentApp) {
    connection.sendEvent(message)
  } else {
    // TODO: Remove after HD rewrite
    window.parent.postMessage(JSON.stringify(message), '*')
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const normalizePostMessageEvent = <T = any>(event: InboxMessage) =>
  ({
    event_name: event.event_name.replace(MESSAGE_PREFIX, ''),
    event_data: event.event_data,
  } as T)
